import React, { useCallback, useRef, useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import {
  IWorkExperience,
  IWorkExperienceFormData,
} from '../../../../interfaces/user-work-experience.interface';
import StepForm from '../StepForm';
import WorkExperienceForm, { FormRef } from './components/WorkExperienceForm';

export interface WorkExperienceFormInputs {
  workExperiences: IWorkExperience[];
}

interface WorkExperienceFormProps {
  onSubmitWorkExperience: SubmitHandler<IWorkExperienceFormData>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  step: number;
  isLoading: boolean;
  savedWorkExperiences?: IWorkExperience[];
}

const WorkExperience = ({
  onSubmitWorkExperience,
  setStep,
  step,
  isLoading,
  savedWorkExperiences,
}: WorkExperienceFormProps) => {
  const formRef = useRef<FormRef | null>(null);
  const [isFormTouched, setIsFormTouched] = useState(false);

  const onNext = () => {
    const handleValidation = formRef?.current?.handleSubmit;

    if (!handleValidation) return;

    const executeSubmission = handleValidation(
      (data: WorkExperienceFormInputs) => {
        onSubmitWorkExperience({ workExperiences: data.workExperiences });
      }
    );
    executeSubmission();
  };

  const onSkip = () => {
    onSubmitWorkExperience({ workExperiences: [] });
  };

  const handleFormTouchChange = useCallback((isTouched: boolean) => {
    setIsFormTouched(isTouched);
  }, []);

  const isNextEnabled = !isLoading && isFormTouched;

  return (
    <StepForm
      title="Work experience"
      onNext={onNext}
      onSkip={onSkip}
      nextDisabled={!isNextEnabled}
      backDisabled={isLoading}
      skipDisabled={isLoading}
      step={step}
      setStep={setStep}
    >
      <WorkExperienceForm
        ref={formRef}
        savedWorkExperiences={savedWorkExperiences}
        onFormTouchChange={handleFormTouchChange}
      />
    </StepForm>
  );
};

export default WorkExperience;
